import React from 'react';
import { HeaderProps } from '../../interfaces';
import ControlledCountdown from './ControlledCountdown';
import SidebarToggleButton from './SidebarToggleButton';
import LogoSection from './LogoSection';
import CartButton from './CartButton';
import AccountIconButton from '../../AccountIconButton';
import AccountQrModal from '../../AccountQrModal';
import useHeader from '../../hooks/useHeader';
import { StyledAppBar, HeaderStack, CountdownContainer, HeaderActionGroup, AccountButtonWrapper } from './style';

const HeaderTheme1: React.FC<HeaderProps> = ({ company, toggleDrawer }) => {
  const {
    showCart,
    showAccount,
    handleNavigateToCart,
    handleAccountClick,
    handleCloseAccountQrModal,
    handleViewProfileFromQrModal,
    handleLogoClick,
    bookingCart,
    countdownApi,
    location,
    isAccountQrModalOpen,
    qrCodeValue,
  } = useHeader(company);

  return (
    <>
      <StyledAppBar position="static" isHome={location.pathname === '/'} className="app-header">
        <HeaderStack direction="row" justifyContent="space-between" alignItems="center">
          <SidebarToggleButton showSidebar={company?.showSidebar} toggleDrawer={toggleDrawer} />
          <LogoSection company={company} onClick={handleLogoClick} />
          <HeaderActionGroup>
            {showAccount && (
              <AccountIconButton
                onClick={handleAccountClick}
                ButtonWrapper={AccountButtonWrapper}
                enableQRCode={company?.enableQRCode}
              />
            )}
            <CartButton
              showCart={showCart}
              cartItemsCount={bookingCart?.length}
              onClick={handleNavigateToCart}
            />
          </HeaderActionGroup>
        </HeaderStack>
      </StyledAppBar>
      {showCart && (
        <CountdownContainer>
          <ControlledCountdown countdownApi={countdownApi} />
        </CountdownContainer>
      )}
      <AccountQrModal
        open={isAccountQrModalOpen}
        onClose={handleCloseAccountQrModal}
        qrCodeValue={qrCodeValue}
        onViewProfile={handleViewProfileFromQrModal}
      />
    </>
  );
};

export default HeaderTheme1;
